/** Which plugin the editor has open, and the check run before saving one. */
import { create } from 'zustand';
import type { InstalledPlugin, PluginManifest } from '@nexus/plugins';

export const usePluginEditor = create<{
  editing: InstalledPlugin | 'new' | null;
  set: (editing: InstalledPlugin | 'new' | null) => void;
}>((set) => ({ editing: null, set: (editing) => set({ editing }) }));

/** Problems with a manifest + code pair, or none. */
export async function checkPlugin(manifest: PluginManifest, code: string): Promise<string | null> {
  const { PluginSandbox } = await import('@nexus/plugins/sandbox');
  let box;
  try {
    box = await PluginSandbox.create(code, { call: async () => null });
  } catch (e) {
    return e instanceof Error ? e.message : String(e);
  }
  try {
    const has = box.registered();
    const missing = [
      ...manifest.blocks.filter((x) => !has.block.includes(x.id)).map((x) => `block "${x.id}"`),
      ...manifest.commands
        .filter((x) => !has.command.includes(x.id))
        .map((x) => `command "${x.id}"`),
      ...manifest.views.filter((x) => !has.view.includes(x.id)).map((x) => `view "${x.id}"`),
      ...manifest.automations
        .filter((x) => !has.automation.includes(x.id))
        .map((x) => `automation "${x.id}"`),
    ];
    return missing.length ? `Ontbreekt in de code: ${missing.join(', ')}` : null;
  } finally {
    box.dispose();
  }
}
